import React, { FunctionComponent } from 'react';
import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconProject: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faProjectDiagram} />;

export { BrassIconProject };
